import { bloqueaTabulador } from "../lib/menu";
var telefonos = function () {
    Array.from(document.querySelectorAll('.bloque--telefonos')).forEach(function (bloque) {
        var botones = Array.from(bloque.querySelectorAll('button'));
        var popup = document.querySelector('#' + bloque.dataset.formulario);
        var cantidades = popup.querySelector('.cantidades__fieldset');
        var radioVacio = cantidades === null || cantidades === void 0 ? void 0 : cantidades.querySelector('input[type="radio"][value=""]');
        bloqueaTabulador(popup);
        var muestraPopup = function (cantidad) { return function (e) {
            e.preventDefault();
            popup.style.opacity = '1';
            if (cantidades && cantidad) {
                var radio = popup.querySelector("input[type=\"radio\"][value=\"".concat(cantidad, "\"]"));
                if (radio) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
                else if (cantidad && radioVacio) {
                    var inputCantidad = cantidades === null || cantidades === void 0 ? void 0 : cantidades.querySelector('input[type="text"]');
                    if (inputCantidad) {
                        inputCantidad.value = cantidad;
                    }
                    radioVacio.checked = true;
                    radioVacio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }; };
        var ocultaPopup = function () { return popup.style.opacity = '0'; };
        botones.forEach(function (boton) { return boton.addEventListener('click', muestraPopup(boton.dataset.cantidad || '')); });
        popup.addEventListener('transitionend', function (e) {
            var _a;
            if (e.target !== popup)
                return;
            if (getComputedStyle(popup).opacity === '0') {
                popup.hidden = true;
                popup.inert = true;
                popup.style.opacity = '';
            }
            else {
                popup.hidden = false;
                popup.inert = false;
                (_a = popup.querySelector('input[type="text"]:not(.pueseso)')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        });
        if (popup.querySelector('.formulario__gracias__mensaje') || popup.querySelector('.formulario__error')) {
            addEventListener('load', function () { return popup.style.opacity = '1'; });
            popup.addEventListener('transitionend', function () {
                if (getComputedStyle(popup).opacity === '0') {
                    location.href = location.href.replace(/gracias.*/, '');
                }
            });
        }
        popup.addEventListener('click', function (event) {
            if (event.target === popup) {
                ocultaPopup();
            }
        });
        addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && getComputedStyle(popup).opacity !== '0') {
                ocultaPopup();
            }
        });
    });
};
export default telefonos;
